var exports = {
  "container": "x24da60e8--685a0d--container",
  "control": "x24da60e8--685a0d--control",
  "phone": "x24da60e8--685a0d--phone",
  "tablet": "x24da60e8--685a0d--tablet",
  "description": "x24da60e8--685a0d--description",
  "title": "x24da60e8--685a0d--title",
  "label-list": "x24da60e8--685a0d--label-list",
  "label-wrapper": "x24da60e8--685a0d--label-wrapper",
};

module.exports = exports;
